import { render, staticRenderFns } from "./needs-pub.vue?vue&type=template&id=7a5b075d&scoped=true&"
import script from "./needs-pub.vue?vue&type=script&lang=js&"
export * from "./needs-pub.vue?vue&type=script&lang=js&"
import style0 from "./needs-pub.vue?vue&type=style&index=0&id=7a5b075d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5b075d",
  null
  
)

export default component.exports